// Script to update font-size within the Inbox shopify plugin

// Wait for an element within a given root (document or shadowRoot)
function waitForElement(selector, root = document) {
    return new Promise(resolve => {
        const tryFind = () => root && root.querySelector ? root.querySelector(selector) : null;
        const immediate = tryFind();
        if (immediate) return resolve(immediate);
        const targetNode = root === document ? document.documentElement : root;
        const observer = new MutationObserver(() => {
            const found = tryFind();
            if (found) {
                observer.disconnect();
                resolve(found);
            }
        });
        observer.observe(targetNode, { childList: true, subtree: true });
    });
}

// Ensure a <style> with given id exists in a shadow root, injecting CSS if missing
function ensureShadowStyle(shadowRoot, styleElementId, cssText) {
    if (!shadowRoot) return;
    let styleEl = shadowRoot.getElementById(styleElementId);
    if (!styleEl) {
        styleEl = document.createElement('style');
        styleEl.id = styleElementId;
        styleEl.textContent = cssText;
        shadowRoot.appendChild(styleEl);
    }
}

document.addEventListener("DOMContentLoaded", async () => {
    // Wait for the chat host element
    const host = await waitForElement('#shopify-chat inbox-online-store-chat');
    const root = host && host.shadowRoot;
    if (!root) return; // likely a closed shadow root

    // Inject persistent CSS into the shadow root so it survives re-renders
    const styleId = 'niuk-chat-title-override';
    const css = `.chat-title { font-size: 24px !important; }`;
    ensureShadowStyle(root, styleId, css);


    // Re-apply the style if the shadow DOM is re-rendered/replaced
    const reapplyObserver = new MutationObserver(() => {
        ensureShadowStyle(root, styleId, css);
    });
    reapplyObserver.observe(root, { childList: true, subtree: true });
});